<template>
  <div class="d-flex w-100 heading">
    <div class="col-1 my-auto text-right arrow dsd-feature-header-arrow-container" @click="onClick()">
      <i class="material-icons dsd-feature-header-arrow">{{ arrowDown ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</i>
    </div>
    <div class="col-11 py-2 d-flex align-items-center">
      <span class="dsd-feature-title" :data-cy="tag" @click="onClick()">{{ titleText }}</span>
      <span v-if="titleCount" class="badge badge-pill badge-primary count-badge" @click="onClick()">{{ titleCount }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ECDatasetDetailsFeatureHeader",
  props: {
    onClick: Function,
    title: String,
    tag: String,
    arrowDown: Boolean,
  },
  computed: {
    titleParts() {
      const rawTitle = this.title || "";
      const match = rawTitle.match(/^(.*)\s\(([^()]+)\)\s*$/);
      if (!match) {
        return { text: rawTitle, count: "" };
      }

      return {
        text: match[1].trim(),
        count: match[2].trim(),
      };
    },
    titleText() {
      return this.titleParts.text;
    },
    titleCount() {
      return this.titleParts.count;
    },
  },
};
</script>

<style lang="scss" scoped>
.heading {
  cursor: pointer;
}

.arrow {
  padding-right: 0;
}

.count-badge {

    margin-left: 10px;
    margin-bottom: 4px;
    color: #000;
}

@media screen and (max-width: 991px) {
  .dsd-feature-header-arrow-container {
    width: 48px !important;
    order: 2;
    padding-right: 15px;
  }
}
</style>
